import { App, Button, Col, Form, Input, Row } from 'antd';
import { ActionDto } from '../../../../dto/reporting-models';
import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { GetAccessToken } from '../../../../utils/auth-utils';
import { scopes } from '../../../../authConfig';
import { reportingService } from '../../../../services/reporting-service';
import { strings } from '../../../../lang';

export const AdminExperience = () => {
  const { instance, inProgress } = useMsal();
  const { message } = App.useApp();
  const [actions, setActions] = useState<ActionDto[] | undefined>();

  useEffect(() => {
    const fetchActions = async () => {
      const token = await GetAccessToken(instance, inProgress, scopes.salesAppointmentApi);
      try {
        const actionsResponse = await reportingService.getActionsAsync(token.accessToken);
        setActions(actionsResponse);
      } catch (error) {}
    };
    fetchActions();
  }, []);

  return (
    <div className="container" style={{ width: 600 }}>
      <Form>
        <Row className="experience-points__grid" gutter={[20, 16]}>
          {actions?.map((point) => (
            <Col key={point.actionId} xs={24} lg={12}>
              <div className="experience-points__action-control">
                <label htmlFor={`experience-points-${point.actionId}`}>{point.actionType}</label>
                <div className="experience-points__value">
                  <Form.Item>
                    <Input
                      id={`experience-points-${point.actionId}`}
                      aria-label={`${point.actionType} ${strings.gamificationSettings.experiencePointsTab}`}
                      type="number"
                      defaultValue={point.points}
                      onChange={(e) => (point.points = +e.target.value)}
                    />
                  </Form.Item>
                  <span className="experience-points__unit">XP</span>
                </div>
              </div>
            </Col>
          ))}
        </Row>
        <Form.Item className="experience-points__save-action">
          <Button
            style={{ float: 'right' }}
            type="primary"
            disabled={!actions}
            onClick={async () => {
              reportingService
                .modifyActionsAsync((await GetAccessToken(instance, inProgress, scopes.salesAppointmentApi)).accessToken, actions!)
                .then(() => {
                  message.success(strings.gamificationSettings.updateSuccess);
                })
                .catch(() => {
                  message.error(strings.gamificationSettings.updateFailed);
                });
            }}
          >
            {strings.gamificationSettings.saveChanges}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
